import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectScopeSelectValue = createSelector(
  [selectComposedReportState],
  ({ scopeValue }) => scopeValue
)
